import {
  Title,
  Text,
  Button,
  Container,
  Flex,
  Image,
  Card,
  rem,
  useMantineTheme,
  SimpleGrid,
  Group,
  Center,
} from "@mantine/core";
import classes from "./CallToAction.module.scss";
import React from "react";

interface CallToActionProps {
  title?: any;
  description?: any;
  primaryButton: {
    text: any;
    onClick?: any;
    link?: string;
  };
}

export default function CallToAction({title, description, primaryButton}: CallToActionProps) {
  const theme = useMantineTheme();
  return (
    <Container size="lg" p={"lg"} pb="xl">
      <div className={classes.inner}>
        {title && (
          <Title order={2} size="h1" className={classes.title}>
            {title}
          </Title>
        )}

        {description && (
          <Container p={0} m={0} size={600}>
            <Text size="lg" className={classes.description}>
              {description}
            </Text>
          </Container>
        )}

        {primaryButton && (
          <Center>
            <Button
              mt={rem(30)}
              radius="xl"
              size="lg"
              className={classes.control}
              onClick={primaryButton.onClick ? (e) => primaryButton.onClick?.() : undefined}
              renderRoot={primaryButton.link ? (props) => <a href={primaryButton.link} {...props} /> : undefined}>
              {primaryButton.text}
            </Button>
          </Center>
        )}
      </div>
    </Container>
  );
}
